import { useEffect, useState } from "react";

// Returns true once the app has hydrated on the client. Use to gate
// browser-only rendering (chat widget, localStorage, etc.) in SSR.
export function useHydrated() {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
